/**
 * Section container with consistent max width and vertical padding. Renders a
 * <section> by default; pass `as="div"` for nested use.
 *
 * @param {Object} props
 * @param {string} [props.id] - anchor id for in-page links
 * @param {import("react").ReactNode} props.children - section content
 * @param {string} [props.className] - extra classes on the outer element
 * @param {string} [props.innerClassName] - extra classes on the inner max-width container
 * @param {"section" | "div"} [props.as] - element tag, defaults to section
 * @returns {import("react").ReactElement}
 */
export function Section(props) {
  const { id, children, className = "", innerClassName = "", as: Tag = "section" } = props;

  return (
    <Tag id={id} className={`relative px-6 py-16 md:py-20 ${className}`.trim()}>
      <div className={`mx-auto max-w-[1240px] ${innerClassName}`.trim()}>{children}</div>
    </Tag>
  );
}
